import { marked } from 'marked';

/** The host's synchronous GFM core. Callers own decoding and final sanitization. */
export function parseMarkdown(source) {
  return marked.parse(source, { async: false });
}
